import { Box, Chip, Collapse, IconButton, Stack, TableCell, TableRow, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { useState } from "react"
import { KeyValue } from "./key-value"
import { JsonBlock } from "./json-block"

export function ActivityRow({ entry }) {
    const [expanded, setExpanded] = useState(false)
    const isOk = entry.outcome === "ok"
    const colour =
        entry.outcome === "primary-user-guard" ||
        entry.outcome === "over-license" ||
        entry.outcome === "circuit-breaker"
            ? "warning"
            : isOk
              ? "success"
              : "error"
    const hasExtra = entry.actor || entry.before || entry.after

    return (
        <>
            <TableRow hover sx={{ cursor: hasExtra ? "pointer" : "default" }} onClick={handleRowClick}>
                <TableCell>
                    {hasExtra && (
                        <IconButton
                            aria-label={expanded ? "Hide details" : "Show details"}
                            size="small"
                            onClick={handleIconClick}
                        >
                            <Iconify icon={expanded ? "mdi:chevron-down" : "mdi:chevron-right"} />
                        </IconButton>
                    )}
                </TableCell>
                <TableCell sx={{ whiteSpace: "nowrap", fontFamily: "monospace", fontSize: 12 }}>
                    {new Date(entry.createdAt).toLocaleString()}
                </TableCell>
                <TableCell>
                    <Stack direction="row" spacing={0.5} alignItems="center">
                        <Chip size="small" label={entry.operation} />
                        <Typography variant="caption" color="text.secondary">
                            {entry.resourceType}
                        </Typography>
                    </Stack>
                </TableCell>
                <TableCell sx={{ fontFamily: "monospace", fontSize: 12 }}>
                    {entry.externalId || entry.resourceId || "—"}
                </TableCell>
                <TableCell>
                    <Chip size="small" label={entry.outcome || "—"} color={colour} variant="outlined" />
                </TableCell>
                <TableCell sx={{ fontSize: 12, color: "text.secondary" }}>{entry.detail || ""}</TableCell>
            </TableRow>
            {hasExtra && (
                <TableRow>
                    <TableCell colSpan={6} sx={{ py: 0, borderBottom: expanded ? undefined : 0 }}>
                        <Collapse in={expanded} timeout="auto" unmountOnExit>
                            <Box sx={{ p: 2, bgcolor: "background.default" }}>
                                <Stack spacing={1.5}>
                                    <KeyValue label="Actor" value={entry.actor || "—"} mono />
                                    <JsonBlock label="Before" value={entry.before} />
                                    <JsonBlock label="After" value={entry.after} />
                                </Stack>
                            </Box>
                        </Collapse>
                    </TableCell>
                </TableRow>
            )}
        </>
    )

    function handleRowClick() {
        if (hasExtra) setExpanded((v) => !v)
    }

    function handleIconClick(e) {
        e.stopPropagation()
        setExpanded((v) => !v)
    }
}
